import { binaryDenseCPU, binarySparseCPU } from '../cpu';
export function multiplyDenseCPU(a, b, resultShape, alpha) {
    return binaryDenseCPU(a, b, resultShape, (a, b) => alpha * a * b);
}
export function multiplySparseCPU(a, b, resultShape, alpha) {
    return binarySparseCPU(a, b, resultShape, (a, b) => alpha * a * b);
}
//# sourceMappingURL=cpu.js.map